import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createSlots as _createSlots, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "notification-center-wrapper" };
const _hoisted_2 = { class: "notification-center" };
const _hoisted_3 = {
    id: "button-show-notification-panel",
    class: "relative flex items-center justify-center"
};
const _hoisted_4 = {
    key: 0,
    class: "absolute -top-1 -right-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-destructive px-1 text-[10px] font-medium text-white"
};
const _hoisted_5 = {
    key: 0,
    class: "skeleton-container"
};
const _hoisted_6 = { class: "mb-4 flex items-start gap-3" };
const _hoisted_7 = { class: "flex min-w-0 flex-1 flex-col gap-3" };
const _hoisted_8 = {
    key: 0,
    class: "flex items-center justify-center gap-2 py-3 text-muted-foreground"
};
const _hoisted_9 = { class: "no-notifications" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        _createCommentVNode(" Toast-style push notifications, rendered outside the menu. "),
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createVNode(_TransitionGroup, { name: "fade" }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.incomeNotifications, (notification) => {
                            return (_openBlock(), _createBlock($setup["EnNotificationPushItem"], {
                                key: notification.timestamp,
                                item: notification,
                                "onOn:notification:read": $setup.removeNotificationFromCenter
                            }, null, 8 /* PROPS */, ["item"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                })
            ])
        ]),
        _createVNode($setup["PopoverRoot"], {
            open: $setup.isOpen,
            "onUpdate:open": _cache[3] || (_cache[3] = ($event) => (($setup.isOpen) = $event))
        }, {
            default: _withCtx(() => [
                _createVNode($setup["PopoverTrigger"], { "as-child": "" }, {
                    default: _withCtx(() => [
                        _createElementVNode("button", _hoisted_3, [
                            _createVNode($setup["Bell"], { color: "background" }),
                            ($setup.unreadNotificationsCount > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($setup.unreadNotificationsCount), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                        ])
                    ]),
                    _: 1 /* STABLE */
                }),
                _createVNode($setup["PopoverContent"], {
                    align: "end",
                    class: "w-[450px] p-0",
                    "side-offset": 6,
                    onInteractOutside: $setup.onCloseAttempt,
                    onEscapeKeyDown: $setup.onCloseAttempt,
                    onOpenAutoFocus: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["prevent"]))
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", {
                            class: "relative",
                            "data-guided-tour-step": $setup.guidedTourStepId
                        }, [
                            _createVNode($setup["EnTabs"], {
                                modelValue: $setup.activeTab,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($setup.activeTab) = $event)),
                                tabs: $setup.tabs,
                                class: "p-2 pb-0"
                            }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                                _renderList($setup.tabs, (tab) => {
                                    return {
                                        name: tab.id,
                                        fn: _withCtx(() => [
                                            _createCommentVNode(" Loading: initial fetch for this tab "),
                                            ($setup.loading)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.skeletonCount, (n) => {
                                                        return (_openBlock(), _createElementBlock(_Fragment, { key: n }, [
                                                            _createElementVNode("div", _hoisted_6, [
                                                                _createVNode($setup["EnSkeleton"], {
                                                                    circle: "",
                                                                    width: "w-6",
                                                                    height: "h-6",
                                                                    class: "shrink-0"
                                                                }),
                                                                _createElementVNode("div", _hoisted_7, [
                                                                    _createVNode($setup["EnSkeleton"], {
                                                                        width: "w-20",
                                                                        height: "h-4"
                                                                    }),
                                                                    _createVNode($setup["EnSkeleton"], {
                                                                        width: "w-full",
                                                                        height: "h-8"
                                                                    })
                                                                ])
                                                            ]),
                                                            _cache[4] || (_cache[4] = _createElementVNode("hr", null, null, -1 /* CACHED */))
                                                        ], 64 /* STABLE_FRAGMENT */));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ]))
                                                : ($setup.itemsForTab(tab.id).length > 0)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                        _createCommentVNode(" Notifications list "),
                                                        _createElementVNode("div", {
                                                            class: "max-h-[700px] min-h-[350px] px-4 overflow-y-auto scroll-fade",
                                                            onScroll: $setup.onScroll
                                                        }, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.itemsForTab(tab.id), (item) => {
                                                                return (_openBlock(), _createElementBlock("div", {
                                                                    key: item.timestamp,
                                                                    class: "last:[&_.notification-list-item-container]:border-b-0"
                                                                }, [
                                                                    _createVNode($setup["EnNotificationListItem"], {
                                                                        item: item,
                                                                        "can-be-read": tab.id === $setup.NotificationType.New,
                                                                        "onOn:notification:read": _cache[0] || (_cache[0] = ($event) => ($setup.markNotificationAsRead($event, true)))
                                                                    }, null, 8 /* PROPS */, ["item", "can-be-read"])
                                                                ]));
                                                            }), 128 /* KEYED_FRAGMENT */)),
                                                            _createCommentVNode(" Loading more: appended while the next page is fetched on scroll "),
                                                            ($setup.loadingMore)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                                    _createVNode($setup["Loader"], { class: "size-4 animate-spin" }),
                                                                    _createElementVNode("span", null, _toDisplayString($setup.t('common.notifications.loadingMore')), 1 /* TEXT */)
                                                                ]))
                                                                : _createCommentVNode("v-if", true)
                                                        ], 32 /* NEED_HYDRATION */)
                                                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                        _createCommentVNode(" Empty state "),
                                                        _createElementVNode("div", _hoisted_9, [
                                                            _createVNode($setup["NoNotificationsIcon"]),
                                                            _createElementVNode("span", null, _toDisplayString($setup.t('common.notifications.clear')), 1 /* TEXT */)
                                                        ])
                                                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                        ])
                                    };
                                })
                            ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "tabs"]),
                            ($setup.canMarkAllAsRead)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "mark-all-as-read-button",
                                    onClick: $setup.markAllNotificationsAsRead
                                }, [
                                    _createVNode($setup["MarkAllNotificationsAsReadIcon"]),
                                    _createElementVNode("span", null, _toDisplayString($setup.t('common.notifications.markAllNotificationsAsRead')), 1 /* TEXT */)
                                ]))
                                : _createCommentVNode("v-if", true)
                        ])
                    ]),
                    _: 1 /* STABLE */
                })
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["open"])
    ]));
}
